import React, { useState } from 'react';
import { ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'completo' | 'basico'>('completo');
  const checkoutBasico = 'https://argentina.recursodigital.shop/cart/48784999153883:1';
  const checkoutCompleto = 'https://argentina.recursodigital.shop/cart/48784999678171:1';
  return <section id="oferta" className="bg-brand-grayLight py-8 px-5 scroll-mt-10 relative" data-id="element-177">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-178">
        <div className="text-center mb-10" data-id="element-179">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4" data-id="element-180">
            Elegí tu{' '}
            <span className="text-brand-primary" data-id="element-181">sistema profesional:</span>
          </h2>
          <p className="text-sm text-slate-500 font-medium" data-id="element-182">
            Las dos opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        <button onClick={() => setSelected('basico')} className={`w-full text-left bg-white rounded-2xl p-6 mb-4 border-2 transition-all shadow-sm ${selected === 'basico' ? 'border-brand-primary ring-4 ring-brand-primary/10' : 'border-slate-100 hover:border-slate-200'}`} data-id="element-183">
          <div className="flex items-start gap-4" data-id="element-184">
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 mt-1 flex items-center justify-center ${selected === 'basico' ? 'border-brand-primary' : 'border-slate-300'}`} data-id="element-185">
              {selected === 'basico' && <div className="w-3 h-3 rounded-full bg-brand-primary" data-id="element-186" />}
            </div>
            <div className="flex-grow min-w-0" data-id="element-187">
              <div className="flex items-start justify-between gap-4 mb-1" data-id="element-188">
                <div className="flex items-center gap-2" data-id="element-189">
                  <span className="text-xl flex-shrink-0" data-id="element-190">📘</span>
                  <h4 className="text-base font-black text-slate-900 uppercase leading-tight" data-id="element-191">
                    MEGAPACK PELUQUERÍA LISTA™
                  </h4>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-192">
                  <div className="text-[10px] text-slate-400 line-through font-medium" data-id="element-193">
                    $27.990 ARS
                  </div>
                  <div className="text-xl font-black text-slate-900 leading-none" data-id="element-194">
                    $19.990
                  </div>
                </div>
              </div>
              <p className="text-sm text-slate-500 font-medium" data-id="element-195">
                6 tomos + 6 bonos
              </p>
            </div>
          </div>
        </button>

        <button onClick={() => setSelected('completo')} className={`w-full text-left bg-white rounded-2xl p-6 relative border-2 transition-all shadow-md ${selected === 'completo' ? 'border-brand-primary ring-4 ring-brand-primary/10' : 'border-slate-100 hover:border-slate-200'}`} data-id="element-196">
          <div className="flex items-start gap-4" data-id="element-197">
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 mt-1 flex items-center justify-center ${selected === 'completo' ? 'border-brand-primary' : 'border-slate-300'}`} data-id="element-198">
              {selected === 'completo' && <div className="w-3 h-3 rounded-full bg-brand-primary" data-id="element-199" />}
            </div>
            <div className="flex-grow min-w-0" data-id="element-200">
              <div className="flex items-start justify-between gap-4 mb-2" data-id="element-201">
                <div className="flex items-center gap-2" data-id="element-202">
                  <span className="text-xl flex-shrink-0" data-id="element-203">🏆</span>
                  <h4 className="text-base font-black text-slate-900 uppercase leading-tight" data-id="element-204">
                    MEGAPACK + KIT DE IMPLEMENTACIÓN PROFESIONAL™
                  </h4>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-205">
                  <div className="text-[10px] text-slate-400 line-through font-medium" data-id="element-206">
                    $49.990 ARS
                  </div>
                  <div className="text-xl font-black text-slate-900 leading-none" data-id="element-207">
                    $27.990
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-2 mb-3" data-id="element-208">
                <span className="bg-brand-accent text-white text-[10px] font-black px-3 py-1 rounded-full" data-id="element-209">
                  ⭐ MÁS ELEGIDO
                </span>
                <span className="bg-green-100 text-green-700 text-[10px] font-black px-3 py-1 rounded-full" data-id="element-210">
                  AHORRÁS MÁS DE $20.000
                </span>
              </div>
              <p className="text-sm text-slate-600 font-bold leading-tight" data-id="element-211">
                6 tomos + 6 bonos + sistema completo de implementación
              </p>
            </div>
          </div>
        </button>

        <a href={selected === 'completo' ? checkoutCompleto : checkoutBasico} className="block w-full btn-premium text-lg md:text-xl py-[20px] px-[36px] rounded-[20px] transition-all hover:scale-[1.02] text-center mt-10 mb-8 no-underline" data-id="element-212">
          {selected === 'completo' ? 'SÍ, QUIERO TODO EL SISTEMA →' : 'QUIERO MI MEGAPACK AHORA →'}
        </a>

        <div className="bg-white border border-slate-100 rounded-2xl py-6 px-6 shadow-sm" data-id="element-213">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-4 text-xs font-bold text-slate-500" data-id="element-214">
            <div className="flex items-center gap-2" data-id="element-215">
              <Lock size={16} className="text-brand-primary" data-id="element-216" />
              Pago seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-217">
              <Zap size={16} className="text-brand-primary" data-id="element-218" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2" data-id="element-219">
              <ShieldCheck size={16} className="text-brand-primary" data-id="element-220" />
              Garantía 7 días
            </div>
          </div>
          <div className="flex items-center justify-center gap-3 mt-6 pt-6 border-t border-slate-50" data-id="element-221">
            <CreditCard size={18} className="text-brand-primary flex-shrink-0" data-id="element-222" />
            <span className="text-xs text-slate-500 font-bold text-center" data-id="element-223">
              Pagá con tarjeta o MercadoPago de forma segura y accedé al
              material HOY
            </span>
          </div>
        </div>
      </div>
    </section>;
}